import React, { useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox } from '@progress/kendo-react-inputs'
import { Label } from '@progress/kendo-react-labels'
import { Grid, useMediaQuery } from '@material-ui/core'
import { PDFDocument } from 'pdf-lib'

import {
  Traslates,
  CheckBoxTemplatePure,
  DialogSystemGLPure,
  ButtonHLPure,
  DataPickerHLPure,
  SignatoryListAutographPure,
  SequentialSigner,
  InputSwitchHLPure,
  LabelHLPure
} from '../../pures'
import DialogSignerContainer from '../../pures/signatory-list/dialog-signer'
import LabelPure from '../../pures/label/label.pure'
import { LocalStorageService } from '../../../services'
import './signature-request-profile-signers.css'

const SignatureRequestProfileSignersView = (props) => {
  const { t } = useTranslation();
  const {
    step,
    signerToDelete,
    onHandleBack,
    signatureTypesInputValue,
    setSignatureTypes,
    setProcessTypes,
    processTypesInputValue,
    signers,
    signatures,
    dispatch,
    signatureProfileSelected,
    proofOfLifeChecked
  } = props;

  let localStorageService = new LocalStorageService()
  let preferredLanguage = localStorageService.getLocalStorageItem("preferredLanguage")

  useEffect(() => {
    if (signerToDelete === '') dispatch({ type: "deleteSignatures", payload: signers })
  }, [signerToDelete])

  const { next, back } = step;
  const [currentSystem, setCurrentSystem] = useState("");
  const [isAddStakehoderActive, setIsAddStakehoderActive] = useState(false);
  const [isAddValidatorActive, setIsAddValidatorActive] = useState(false);
  const [isAddGuestActive, setIsAddGuestActive] = useState(false);
  const [loadingSignature, setLoadingSignature] = useState(false)
  const [stillSigning, setStillSigning] = useState(false)

  const [currentUser, setCurrentUser] = useState({});

  const canUseOrShowProofOfLife = useMemo(() => props.proofOfLifeChecked && props.signatureTypeAutographChecked && (props.processTypeId === +process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL || props.processTypeId === +process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL_APPROVAL), [props.signatureTypeAutographChecked, props.processTypeId, props.proofOfLifeChecked])

  let pdfFile = "data:application/pdf;filename=file.pdf;base64," + props.selectedFileBase64;

  //PRUEBA DE PDF
  const createPdf = () => {
    let signatureData = signatures.map((i, j) => ({
      x: i.x,
      y: i.y,
      width: i.width,
      height: i.height,
      page: i.page,
      isMobile: true,
      fileSignImage: i.fileSignImage,
      imgSignature: i.imgSignature,
      fileName: `sign${j + 1}`,
    }));
    // setSignatures(signatureData);
    insertSignByCoordinates(signatureData);
  };

  useEffect(() => {
    createPdf();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signatures]);

  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  useEffect(() => {
    if (props.signers.find((i) => !i.email))
      props.setSigners(props.signers.filter((i) => !!i.email));
    if (props.validators.find((i) => !i.email))
      props.setValidators(props.validators.filter((i) => !!i.email));
  }, [props.signers, props.validators]);

  useEffect(() => {
    if (props.signatureTypes.length > 0) {
      setSignatureTypes(
        props.signatureTypes.map((item) => ({ ...item, isActive: false }))
      );
    }
    if (props.processTypes.length > 0) {
      setProcessTypes(
        props.processTypes.map((item) => ({ ...item, isActive: false }))
      );
    }
  }, [props.signatureTypes, props.processTypes]);

  useEffect(() => {
    setIsAddStakehoderActive(false);
    setIsAddGuestActive(false);
    setIsAddValidatorActive(false);
  }, [props.signers.length]);

  useEffect(() => {
    if (!props.signerInEdit) {
      setIsAddGuestActive(false);
      setIsAddValidatorActive(false);
      setIsAddStakehoderActive(false);
    }
  }, [props.signerInEdit]);

  useEffect(() => {
    if (props.firmante) {
      let id_order = "";
      const element = props.signers.length;
      id_order = element + 1;
      props.selectSigner({
        nameSigner: props.userInformationFirstName,
        lastNameSigner: `${props.userInformationFirstLastName} ${props.userInformationSecondLastName}`,
        nameCompleted: `${props.userInformationFirstName} ${props.userInformationFirstLastName}`,
        email: props.userInformationEmail,
        type: Number(process.env.REACT_APP_SIGNERS_TYPE_ADMINISTRADOR),
        typeName: "Administrador",
        id_order,
      });
    }
  }, [props.firmante]);

  // Get a list of collaborators based on a provided text
  // const getCollaborator = async (value) => {
  props.collaboratorListAllow.map((collaborator) => {
    collaborator.name = collaborator.firstName + " " + collaborator.firstLastName + " " + collaborator.secondLastName;
    collaborator.email = collaborator.email;
    collaborator.isAssigned = false
  })
  // let results = [];
  // for (let i = 0; i < props.collaboratorListAllow.length; i++) {
  //   let emailExtract = props.collaboratorListAllow[i].email
  //     .split("@")[0]
  //     .toLowerCase();
  //   let addEmail = emailExtract.includes(value.trim().toLowerCase());
  //   if (addEmail === true) results.push(props.collaboratorListAllow[i].email);
  // }
  // return results;
  // };

  // Get a list of guest based on a provided text
  // const getGuestName = async (value) => {
  //   let results = [];
  //   for (let i = 0; i < props.inviteListAllow.length; i++) {
  //     let emailExtract = props.inviteListAllow[i].email
  //       .split("@")[0]
  //       .toLowerCase();
  //     let addEmail = emailExtract.includes(value.trim().toLowerCase());
  //     if (addEmail === true) results.push(props.inviteListAllow[i].email);
  //   }
  //   return results;
  // };

  props.inviteListAllow.map((invited) => {
    invited.name = invited.firstName + " " + invited.firstLastName + " " + invited.secondLastName;
    invited.email = invited.email;
    invited.isAssigned = false
  })

  const handleSignaturesTypes = (params, index) => {
    setSignatureTypes(
      signatureTypesInputValue.map((j, i) =>
        i === index
          ? { ...j, isActive: params.value }
          : { ...j, isActive: false }
      )
    );
  };
  //   const handleSignaturesTypes = (params, index) => props.signatureTypes.map((j, i) => i === index ? { ...j, isActive: params.value } : { ...j, isActive: false })

  const insertSignByCoordinates = async (signatureData) => {
    if (!!signatureData.find((i) => i.imgSignature) && loadingSignature) {
      setLoadingSignature(true)
      const pdfDoc = await PDFDocument.load("data:application/pdf;filename=data.pdf;base64," + props.selectedFileBase64);
      const pages = pdfDoc.getPages()
      for (let index = 0; index < signatureData.length; index++) {
        const { x, y, width, height, page, isMobile, imgSignature } =
          signatureData[index];
        if (imgSignature) {
          const pageToSign = page <= 0 ? pages[0] : pages[page - 1];
          const heightPage = pageToSign.getHeight();
          const pngSignImage = await pdfDoc.embedPng(imgSignature);
          pngSignImage.scale(1);
          pageToSign.drawImage(pngSignImage, {
            x,
            y: isMobile ? y : heightPage - y - height,
            width,
            height,
          });
        }
      }
      const pdfBytes = await pdfDoc.saveAsBase64({ dataUri: true });
      props.saveNewPdf(pdfBytes)
    } else {
      props.saveNewPdf(pdfFile)
    }
  };

  const handleProcessTypes = (params, index) => {
    setProcessTypes(
      processTypesInputValue.map((j, i) =>
        i === index
          ? { ...j, isActive: params.value }
          : { ...j, isActive: false }
      )
    );
    props.resetNotErrors();
  };

  const handleSelectservices = (params, index) => {
    props.setServices(
      props.services.map((j, i) =>
        i === index
          ? { ...j, isActive: params.value }
          : { ...j, isActive: false }
      )
    );
  };

  let infodevice = currentSystem.toLowerCase();
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");

  function isTouchScreendevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }

  if (isTouchScreendevice()) {
    isMobile = true;
  }

  //   let isSignatureTypeSelected = signatureTypesInputValue.find(i => i.isActive)
  let isSignatureTypeSelected =
    props.signatureTypeAutographChecked === true
      ? props.signatureTypeAutographChecked
      : false || props.signatureTypeESignChecked === true
        ? props.signatureTypeESignChecked
        : false || props.signatureTypeAdvancedChecked === true
          ? props.signatureTypeAdvancedChecked
          : false;
  //   let isAtgrafSignature = String((isSignatureTypeSelected || {}).id) === String(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA)
  let isAtgrafSignature =
    String(props.signatureTypeId) ===
    String(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA);

  const isMobileSize = useMediaQuery("(max-width:560px)");
  const hideChecks = isMobileSize && isAtgrafSignature;

  const gridContainerTableSignersStyles = {
    display: "flex",
    alignItems: "center",
    marginBottom: "32px",
    marginTop: "32px",
    flexWrap: "wrap",
    marginLeft: "22px"
  };

  const onHandleSubmit = () => {
    // if ((props.errorCurrentLimitDate === false && props.date) &&
    //     // props.servicesId.length > 0 &&
    //     props.signatureTypeId !== '' &&
    //     props.processTypeId !== '' &&
    //     props.signers.length > 0 &&
    //     props.validators.length > 0
    //     )
    //     onHandleNext()
    props.onSigners();
  };

  const [authorizer, authorizerChecked] = useState(false);
  const [signerBox, signerBoxChecked] = useState(false);

  const authorizerTypeCheck = (event) => {
    if (event.value) {
      props.setValidators(
        props.validators.concat({
          nameSigner: `${props.userInformationFirstName} ${props.userInformationFirstLastName} ${props.userInformationSecondLastName}`,
          lastNameSigner: `${props.userInformationFirstLastName} ${props.userInformationSecondLastName}`,
          nameCompleted: `${props.userInformationFirstName} ${props.userInformationFirstLastName}`,
          email: props.userInformationEmail,
          type: Number(
            process.env.REACT_APP_SIGNERS_TYPE_VALIDATOR
          ),
          typeName: "Administrador",
          id_order: 0,
        })
      );
    } else
      props.setValidators(
        props.validators.filter(
          (i) => i.email !== props.userInformationEmail
        )
      )
  };

  const signersTypeCheck = (event) => {
    signerBoxChecked(event.value);
    if (event.value) {
      props.setSigners(
        props.signers.concat({
          nameSigner: `${props.userInformationFirstName} ${props.userInformationFirstLastName} ${props.userInformationSecondLastName}`,
          lastNameSigner: `${props.userInformationFirstLastName} ${props.userInformationSecondLastName}`,
          nameCompleted: `${props.userInformationFirstName} ${props.userInformationFirstLastName}`,
          email: props.userInformationEmail,
          type: Number(process.env.REACT_APP_SIGNERS_TYPE_ADMINISTRADOR),
          typeName: "Administrador",
          id_order: 0,
          sendDocument: true,
          proofOfLife: false
        })
      );
    } else {
      dispatch({ type: "deleteOwnSignatures", payload: props.userInformationEmail })
      props.setSigners(
        props.signers.filter((i) => i.email !== props.userInformationEmail)
      );
    }
  };

  return (
    <div className="container-signature-profile-signers">
      <Grid
        container
        xs={12}
        className="container-signers"
        spacing={3}
      >
        <Grid item xs={12}>
          <LabelPure title={`${t("signatureRequestProfileView.signatureName")} ${props.nameSignature}`} />
        </Grid>

        {props.selectedFile && (
          <Grid item xs={12}>
            {/* DatePicker for limitDate */}
            <Grid item xs={12}>
              <Traslates>
                <DataPickerHLPure
                  id={"date"}
                  labelDataPicker={t("signatureRequestView2.tooltipLimit")}
                  valueDate={props.date}
                  limitDate={props.dateOriginal}
                  errorInput={props.errorCurrentLimitDate}
                  errorDatePicker={props.errorMessageCurrentLimitDate}
                  handleChangeDate={props.handleChangeLimitDate}
                  tooltipShow
                  informationIcon
                  titleTooltip={t("signatureRequestView2.limitDate")}
                  positionTooltip="top"
                  descriptionTooltip={t("signatureRequestView2.tooltipLimitDateDescription")}
                  formatPicker="dd/MM/yyyy"
                />
              </Traslates>
            </Grid>

            {/* Checkboxes aditional services */}
            <Grid
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="container-services"
            >
              <LabelHLPure
                text={t("signatureRequestView2.services")}
                showTooltip={true}
                titleTooltip={t('signatureRequestView2.aditionalServices')}
                descriptionTooltip={t('signatureRequestView2.servicesDetail')}
                positionTooltip={isMobileSize ? 'top' : 'right'}
                informationIcon={true}
              />
              <div className='signatureRequestProfileSignersView-psc-container'>
                {/* PSC service */}
                <InputSwitchHLPure
                  id={'pscService'}
                  name={'pscService'}
                  customLabelClass='signatureRequestProfileSignersView-psc-label'
                  labelInput={t('signatureProfilesView.serviceConservation')}
                  checked={props.serviceCMChecked}
                  onChange={(e) => props.onSelectServiceCM(e)}
                />
              </div>
            </Grid>

            {/* Checkboxes signatureTypes */}
            {!!props.selectedFile && (
              <Grid
                lg={12}
                md={12}
                sm={12}
                xs={12}
                es={8}
                className='container-signerType'
              >
                <LabelHLPure
                  text={t('signatureRequestView2.tooltipSignatureTypes')}
                  showTooltip={true}
                  titleTooltip={t('signatureRequestView2.tooltipSignatureTypes')}
                  descriptionTooltip={t('signatureRequestView2.tooltipSignatureTypesOne')}
                  positionTooltip={isMobileSize ? 'top' : 'right'}
                  informationIcon={true}
                />

                <div className='checkBox-signatureTypes'>
                  {props.signatureTypeESignWillShow === true ? (
                    <CheckBoxTemplatePure
                      label={t('signatureProfilesView.eSign')}
                      id={'signatureTypeESign'}
                      name={'eSign'}
                      value={props.signatureTypeESignChecked}
                      checked={props.signatureTypeESignChecked}
                      onChange={props.onSelectESign}
                      placeHolder
                      showTooltip={true}
                      titleTooltip={t('signatureProfilesView.eSign')}
                      descriptionTooltip={t('signatureProfilesView.tooltips.eSign.description')}
                      positionTooltip={isMobileSize ? 'top' : 'right'}
                      informationIcon={true}
                    />
                  ) : null}

                  {props.signatureTypeAdvancedWillShow === true ? (
                    <CheckBoxTemplatePure
                      label={t('signatureProfilesView.advanced')}
                      id={'signatureTypeAdvanced'}
                      name={'advanced'}
                      value={props.signatureTypeAdvancedChecked}
                      checked={props.signatureTypeAdvancedChecked}
                      onChange={props.onSelectAdvanced}
                      placeHolder
                      showTooltip={true}
                      titleTooltip={t('signatureProfilesView.advanced')}
                      descriptionTooltip={t('signatureProfilesView.tooltips.advanced.description')}
                      positionTooltip={isMobileSize ? 'top' : 'right'}
                      informationIcon={true}
                    />
                  ) : null}

                  {props.signatureTypeAutographWillShow === true ? (
                    <div className='signatureRequestProfileSignersView-container-ditial-sign'>
                      <CheckBoxTemplatePure
                        label={t('signatureProfilesView.autograph')}
                        id={'signatureTypeAutograph'}
                        name={'autograph'}
                        value={props.signatureTypeAutographChecked}
                        checked={props.signatureTypeAutographChecked}
                        onChange={props.onSelectAutograph}
                        placeHolder
                        showTooltip={true}
                        titleTooltip={t('signatureProfilesView.autograph')}
                        descriptionTooltip={t('signatureProfilesView.tooltips.autograph.description')}
                        positionTooltip={isMobileSize ? 'top' : 'right'}
                        informationIcon={true}
                      />
                    </div>
                  ) : null}
                </div>
                {props.errorSignatureTypeId && (
                  <span className='hint-message-error'>
                    {t('signatureRequestProfileSignersView.signatureTypeId')}
                  </span>
                )}
              </Grid>
            )}
            {/* Checkboxes processTypes */}
            {props.processTypesInputValue && (
              <Grid
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className='container-signatureFlow'
              >
                <div>
                  <LabelHLPure
                    text={t('signatureRequestView2.flowSignatures')}
                    showTooltip={true}
                    titleTooltip={t('signatureRequestView2.signatureFlow')}
                    descriptionTooltip={t('signatureRequestView2.flowSignaturesDetail')}
                    positionTooltip={isMobileSize ? 'top' : 'right'}
                    informationIcon={true}
                  />
                  <div className='checkBox-signatureFlow'>
                    {props.processTypeRandomWillShow === true ? (
                      <CheckBoxTemplatePure
                        label={t('signatureProfilesView.random')}
                        id={'processTypeRandom'}
                        name={'random'}
                        value={props.processTypeRandomChecked}
                        checked={props.processTypeRandomChecked}
                        onChange={props.onSelectRandom}
                        placeHolder
                        showTooltip={true}
                        titleTooltip={t('signatureProfilesView.random')}
                        descriptionTooltip={t('signatureProfilesView.tooltips.random.description')}
                        positionTooltip={isMobileSize ? 'top' : 'right'}
                        informationIcon={true}
                      />
                    ) : null}

                    {props.processTypeSequentialWillShow === true ? (
                      <CheckBoxTemplatePure
                        label={t('signatureProfilesView.sequential')}
                        id={'processTypeSequential'}
                        name={'sequential'}
                        value={props.processTypeSequentialChecked}
                        checked={props.processTypeSequentialChecked}
                        onChange={props.onSelectSequential}
                        placeHolder
                        showTooltip={true}
                        titleTooltip={t('signatureProfilesView.sequential')}
                        descriptionTooltip={t('signatureProfilesView.tooltips.sequential.description')}
                        positionTooltip={isMobileSize ? 'top' : 'right'}
                        informationIcon={true}
                      />
                    ) : null}

                    {props.processTypeAprovationlWillShow === true ? (
                      <CheckBoxTemplatePure
                        label={t('signatureProfilesView.aprovation')}
                        id={'processTypeAprovation'}
                        name={'aprovation'}
                        value={props.processTypeAprovationChecked}
                        checked={props.processTypeAprovationChecked}
                        onChange={props.onSelectAprovation}
                        placeHolder
                        showTooltip={true}
                        titleTooltip={t('signatureProfilesView.aprovation')}
                        descriptionTooltip={t('signatureProfilesView.tooltips.aprovation.description')}
                        positionTooltip={isMobileSize ? 'top' : 'right'}
                        informationIcon={true}
                      />
                    ) : null}

                    {props.processTypeAprovationSequentialWillShow === true ? (
                      <CheckBoxTemplatePure
                        label={t('signatureProfilesView.aprovationSequencial')}
                        id={'processTypeAprovationSequencial'}
                        name={'aprovationSequencial'}
                        value={props.processTypeAprovationSequentialChecked}
                        checked={props.processTypeAprovationSequentialChecked}
                        onChange={props.onSelectAprovationSequential}
                        placeHolder
                        showTooltip={true}
                        titleTooltip={t('signatureProfilesView.aprovationSequencial')}
                        descriptionTooltip={t('signatureProfilesView.tooltips.aprovationSequencial.description')}
                        positionTooltip={isMobileSize ? 'top' : 'right'}
                        informationIcon={true}
                      />
                    ) : null}
                  </div>
                </div>
                {(props.signatureTypeAutographChecked && (props.processTypeId === +process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL || props.processTypeId === +process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL_APPROVAL)) &&
                  (
                    <div className={`signatureRequestProfileSignersView-proofOflife-${props.proofOfLifeChecked ? 'on' : 'off'}`}>
                      <div className='signatureRequestProfileSignersView-proofOflife-switch'>
                        <LabelHLPure
                          text={t('signatureProfilesView.biometric.validation')}
                          showTooltip={true}
                          titleTooltip={t('signatureProfilesView.biometric.validation')}
                          descriptionTooltip={t('signatureRequestProfileSignersView.tooltip.govoauth.description')}
                          positionTooltip={isMobileSize ? 'top' : 'right'}
                          informationIcon={true}
                        />
                        <InputSwitchHLPure
                          id={'proofOfLife'}
                          name={'proofoflife'}
                          checked={props.proofOfLifeChecked}
                          onChange={(e) => props.setCheckedProofOfLife(e)}
                        />
                      </div>
                      {proofOfLifeChecked &&
                        <div className='signatureRequestProfileSignersView-container-proofOfLife-checkboxes'>
                          <CheckBoxTemplatePure
                            label={t("signatureProfilesView.biometric.validationType.video")}
                            id={'processTypeAprovation'}
                            name={'aprovation'}
                            value={false}
                            checked={!props.proofOfLifeOnlyPhoto}
                            onChange={props.onChangeProofOfLifeOption}
                          />
                          <CheckBoxTemplatePure
                            label={t("signatureProfilesView.biometric.validationType.photo")}
                            id={'processTypeAprovation'}
                            name={'aprovation'}
                            value={true}
                            checked={props.proofOfLifeOnlyPhoto}
                            onChange={props.onChangeProofOfLifeOption}
                          />
                        </div>
                      }
                    </div>
                  )
                }
                {props.errorProcessTypeId && (
                  <span className="hint-message-error">
                    {t("signatureRequestProfileSignersView.processTypeId")}
                  </span>
                )}
              </Grid>
            )}
          </Grid>
        )}

        {/* Button signers and Table signers */}
        <Grid container lg={12} md={12} sm={12} xm={12} es={12}>
          {props.processTypeId && props.signatureTypeId && (
            <>
              <Grid
                className="add-btns"
                item
                lg={12}
                md={12}
                sm={12}
                es={12}
                style={gridContainerTableSignersStyles}
              >
                {props.processTypeId === 3 && (
                  <div
                    // className={`form-inputs-button-ad-signersone-profile ${isAddValidatorActive
                    //   ? "form-inputs-button-ad-signers-active-profile"
                    //   : ""
                    //   }`}
                    className="form-inputs-button-ad-signersone-profile"
                    onClick={() => {
                      props.getCollabsOrInvites(1)
                      // props.toggleShowDialogList(true)
                      // setIsAddGuestActive(false);
                      // setIsAddStakehoderActive(false);
                      // setIsAddValidatorActive(!isAddValidatorActive);
                      props.insertValidator();
                    }}
                  >
                    <span>
                      <i className="k-icon k-i-plus"></i>
                      {t("signatureRequestView2.addValidator")}
                    </span>
                  </div>
                )}
                {props.processTypeId === 4 && (
                  <div
                    // className={`form-inputs-button-ad-signersone-profile ${isAddValidatorActive
                    //   ? "form-inputs-button-ad-signers-active-profile"
                    //   : ""
                    //   }`}
                    className="form-inputs-button-ad-signersone-profile"
                    onClick={() => {
                      props.getCollabsOrInvites(1)
                      // setIsAddGuestActive(false);
                      // setIsAddStakehoderActive(false);
                      // setIsAddValidatorActive(!isAddValidatorActive);
                      props.insertValidator();
                    }}
                  >
                    <span>
                      <i className="k-icon k-i-plus"></i>
                      {t("signatureRequestView2.addValidator")}
                    </span>
                  </div>
                )}
                <div
                  // className={`form-inputs-button-ad-signersone-profile ${isAddStakehoderActive
                  //   ? "form-inputs-button-ad-signers-active-profile"
                  //   : ""
                  //   }`}
                  className="form-inputs-button-ad-signersone-profile"
                  onClick={() => {
                    // props.toggleShowDialogList(true)
                    props.getCollabsOrInvites(1)
                    // setIsAddGuestActive(false);
                    // setIsAddValidatorActive(false);
                    // setIsAddStakehoderActive(!isAddStakehoderActive);
                    props.insertCollaborator();
                  }}
                >
                  <span>
                    <i className="k-icon k-i-plus"></i>
                    {t("signatureRequestView2.addCollaborator")}
                  </span>
                </div>
                <div
                  // className={`form-inputs-button-ad-signersone-profile ${isAddGuestActive
                  //   ? "form-inputs-button-ad-signers-active-profile"
                  //   : ""
                  //   }`}
                  className="form-inputs-button-ad-signersone-profile"
                  onClick={() => {
                    // props.toggleShowDialogList(true)
                    props.getCollabsOrInvites(2, 0, +process.env.REACT_APP_OFFSET_LIMIT_INVITES)
                    // setIsAddGuestActive(true);
                    // setIsAddStakehoderActive(false);
                    // setIsAddValidatorActive(false);
                    props.insert();
                  }}
                >
                  <span>
                    <i className="k-icon k-i-plus"></i>
                    {t("signatureRequestView2.addInvited")}
                  </span>
                </div>
                {
                  (props.signersNoPassword && props.signatureTypeAutographChecked && !proofOfLifeChecked) && (
                    <div
                      className="form-inputs-button-ad-signersone-profile"
                      onClick={() => {
                        // props.toggleShowDialogList(true)
                        props.getCollabsOrInvites(3, 0, +process.env.REACT_APP_OFFSET_LIMIT_INVITES)
                        props.insertNoPassword();
                      }}
                    >
                      <span>
                        <i className="k-icon k-i-plus"></i>
                        {t("signatureRequestView2.signer.no.password")}
                      </span>
                    </div>
                  )
                }
                <br />

                {(props.processTypeId ===
                  Number(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_APPROVAL) ||
                  props.processTypeId ===
                  Number(
                    process.env
                      .REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL_APPROVAL
                  )) && (
                    <div style={{ marginRight: '6px' }}>
                      <Checkbox
                        className="checkBox-signers"
                        checked={
                          !!props.validators.find(
                            (i) => i.email === props.userInformationEmail
                          )
                        }
                        label={t("signatureRequestView2.firmanteTVal")}
                        onChange={(params) => authorizerTypeCheck(params)}
                        disabled={
                          !!props.validators.find(
                            (i) => i.email === props.userInformationEmail
                          )
                        }
                      />
                    </div>
                  )}
                <br />
                <div
                  style={(preferredLanguage && preferredLanguage === "en") ? { marginLeft: "8px" } : { marginLeft: "0px" }}
                >
                  <Checkbox
                    className="checkBox-signers"
                    checked={
                      !!props.signers.find(
                        (i) => i.email === props.userInformationEmail
                      )
                    }
                    id={"signerCheck"}
                    name={"signerCheck"}
                    label={t("signatureRequestView2.firmanteT")}
                    // disabled={
                    //   !!props.signers.find(
                    //     (i) => i.email === props.userInformationEmail
                    //   )
                    // }
                    onChange={(event) => signersTypeCheck(event)}
                  />
                </div>
                <br />
              </Grid>

              {/* {props.errorNotValidators && props.validators.length < 0 && <span className='hint-message-error'>{t('signatureRequestView2.notAddRequest')}</span>}
          {props.errorNotSigners && props.signers.length === 0 && isSignatureTypeSelected && <span className='hint-message-error'>{t('signatureRequestView2.notAddRequest')}</span>} */}
              <Grid
                className="table-add-signers"
                item
                lg={12}
                md={12}
                sm={12}
                es={12}
                style={{ marginBottom: "20px", marginLeft: "22px" }}
              >
                {props.processTypeId ===
                  Number(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_RANDOM) && (
                    <div>
                      <SignatoryListAutographPure
                        booleanValue={props.signersNoPassword}
                        insertSignBySigner={props.insertSignaturesBySigner}
                        stillSigning={stillSigning}
                        setStillSigning={setStillSigning}
                        currentUser={currentUser}
                        setCurrentUser={setCurrentUser}
                        toggleLoadingRequesting={setLoadingSignature}
                        showLoadingRequesting={loadingSignature}
                        pdfFile={props.newPdf ?? pdfFile}
                        setSignatures={() => dispatch({ type: "setSignatures" })}
                        deleteSignaturesByIndex={(e) => dispatch({ type: "deleteSignatureByIndex", index: e })}
                        deleteSignatures={() => dispatch}
                        signatures={signatures}
                        dispatch={() => dispatch}
                        validateInput={props.validateInput}
                        setSigners={props.setSigners}
                        isSignatureTypeSelected={isSignatureTypeSelected}
                        isAtgrafSignature={isAtgrafSignature}
                        signers={props.signers}
                        toggleDialogDeleteSigner={props.toggleDialogDeleteSigner}
                        signatureTypeAutographChecked={
                          props.signatureTypeAutographChecked
                        }
                        signatureTypeAdvancedChecked={
                          props.signatureTypeAdvancedChecked
                        }
                        signatureTypeESignChecked={props.signatureTypeESignChecked}
                        processTypeAprovationSequentialChecked={
                          props.processTypeAprovationSequentialChecked
                        }
                        processTypeAprovationChecked={
                          props.processTypeAprovationChecked
                        }
                        processTypeRandomChecked={props.processTypeRandomChecked}
                        processTypeSequentialChecked={
                          props.processTypeSequentialChecked
                        }
                        signatureTypeId={props.signatureTypeId}
                        proofLifeCheckboxId={props.proofLifeCheckboxId}
                        showThirdProofLifeCol={canUseOrShowProofOfLife}
                        titleProofLifeCol={t("signatureProfilesView.title.col.biometric validation")}
                      />
                    </div>
                  )}
                {props.processTypeId ===
                  Number(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL) && (
                    <div>
                      <SequentialSigner
                        booleanValue={props.signersNoPassword}
                        isSequentialSignerAuthorization={true}
                        insertSignBySigner={props.insertSignaturesBySigner}
                        stillSigning={stillSigning}
                        setStillSigning={setStillSigning}
                        currentUser={currentUser}
                        setCurrentUser={setCurrentUser}
                        toggleLoadingRequesting={setLoadingSignature}
                        showLoadingRequesting={loadingSignature}
                        validateInput={props.validateInput}
                        setSigners={props.setSigners}
                        isSignatureTypeSelected={isSignatureTypeSelected}
                        isAtgrafSignature={isAtgrafSignature}
                        signers={props.signers.map((item) => ({
                          ...item,
                          key: "signers",
                        }))}
                        type={"signers"}
                        pdfFile={props.newPdf ?? pdfFile}
                        signatures={signatures}
                        setSignatures={() => dispatch({ type: "setSignatures" })}
                        deleteSignaturesByIndex={(e) => dispatch({ type: "deleteSignatureByIndex", index: e })}
                        DragCell={props.DragCell}
                        changeRows={(dataItem, sum) =>
                          props.changeRows(dataItem, sum, "signers")
                        }
                        toggleDialogDeleteSigner={props.toggleDialogDeleteSigner}
                        processTypeAprovationSequentialChecked={
                          props.processTypeAprovationSequentialChecked
                        }
                        processTypeAprovationChecked={
                          props.processTypeAprovationChecked
                        }
                        processTypeRandomChecked={props.processTypeRandomChecked}
                        processTypeSequentialChecked={
                          props.processTypeSequentialChecked
                        }
                        signatureTypeAutographChecked={
                          props.signatureTypeAutographChecked
                        }
                        signatureTypeAdvancedChecked={
                          props.signatureTypeAdvancedChecked
                        }
                        signatureTypeESignChecked={props.signatureTypeESignChecked}
                        signatureTypeId={props.signatureTypeId}
                        signatureProfileSelected={signatureProfileSelected}
                        proofLifeCheckboxId={props.proofLifeCheckboxId}
                        showThirdProofLifeCol={canUseOrShowProofOfLife}
                        titleProofLifeCol={t("signatureProfilesView.title.col.biometric validation")}
                      />
                      {props.errorNotSigners && isSignatureTypeSelected && (
                        <span className="hint-message-error">
                          {t("signatureRequestProfileSignersView.signers")}
                        </span>
                      )}
                    </div>
                  )}

                {props.processTypeId ===
                  Number(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_APPROVAL) && (
                    <React.Fragment>
                      <div>
                        <Label className="form-inputs-labels">
                          {"Autorizadores"}
                        </Label>
                        <SignatoryListAutographPure
                          booleanValue={props.signersNoPassword}
                          validateInput={props.validateInput}
                          setSigners={props.setSigners}
                          isSignatureTypeSelected={isSignatureTypeSelected}
                          signers={props.validators.map((item) => ({
                            ...item,
                            key: "signers",
                          }))}
                          type={"validators"}
                          toggleDialogDeleteSigner={props.toggleDialogDeleteSigner}
                          processTypeAprovationSequentialChecked={
                            props.processTypeAprovationSequentialChecked
                          }
                          processTypeAprovationChecked={
                            props.processTypeAprovationChecked
                          }
                          processTypeRandomChecked={props.processTypeRandomChecked}
                          processTypeSequentialChecked={
                            props.processTypeSequentialChecked
                          }
                          signatureTypeAutographChecked={
                            props.signatureTypeAutographChecked
                          }
                          signatureTypeAdvancedChecked={
                            props.signatureTypeAdvancedChecked
                          }
                          signatureTypeESignChecked={props.signatureTypeESignChecked}
                        />
                      </div>
                      <br />
                      <br />
                      <br />
                      <div>
                        <Label className="form-inputs-labels">{"Firmantes"}</Label>
                        <SignatoryListAutographPure
                          booleanValue={props.signersNoPassword}
                          insertSignBySigner={props.insertSignaturesBySigner}
                          stillSigning={stillSigning}
                          setStillSigning={setStillSigning}
                          currentUser={currentUser}
                          setCurrentUser={setCurrentUser}
                          toggleLoadingRequesting={setLoadingSignature}
                          showLoadingRequesting={loadingSignature}
                          pdfFile={props.newPdf ?? pdfFile}
                          setSignatures={() => dispatch({ type: "setSignatures" })}
                          deleteSignaturesByIndex={(e) => dispatch({ type: "deleteSignatureByIndex", index: e })}
                          deleteSignatures={() => dispatch}
                          signatures={signatures}
                          dispatch={() => dispatch}
                          validateInput={props.validateInput}
                          setSigners={props.setSigners}
                          isSignatureTypeSelected={isSignatureTypeSelected}
                          isAtgrafSignature={isAtgrafSignature}
                          signers={props.signers}
                          toggleDialogDeleteSigner={props.toggleDialogDeleteSigner}
                          signatureTypeAutographChecked={
                            props.signatureTypeAutographChecked
                          }
                          signatureTypeAdvancedChecked={
                            props.signatureTypeAdvancedChecked
                          }
                          signatureTypeESignChecked={props.signatureTypeESignChecked}
                          processTypeAprovationSequentialChecked={
                            props.processTypeAprovationSequentialChecked
                          }
                          processTypeAprovationChecked={
                            props.processTypeAprovationChecked
                          }
                          processTypeRandomChecked={props.processTypeRandomChecked}
                          processTypeSequentialChecked={
                            props.processTypeSequentialChecked
                          }
                          signatureTypeId={props.signatureTypeId}
                          proofLifeCheckboxId={props.proofLifeCheckboxId}
                          showThirdProofLifeCol={canUseOrShowProofOfLife}
                          titleProofLifeCol={t("signatureProfilesView.title.col.biometric validation")}
                        />
                      </div>
                      {props.errorNotSigners && (
                        <span className="hint-message-error">
                          {t("signatureRequestProfileSignersView.signers")}
                        </span>
                      )}
                    </React.Fragment>
                  )}

                {props.processTypeId ===
                  Number(
                    process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL_APPROVAL
                  ) && (
                    <React.Fragment>
                      <div>
                        <Label className="form-inputs-labels">
                          {t("signatureRequestView2.validator")}
                        </Label>
                        <SequentialSigner
                          booleanValue={props.signersNoPassword}
                          stillSigning={stillSigning}
                          setStillSigning={setStillSigning}
                          currentUser={currentUser}
                          setCurrentUser={setCurrentUser}
                          toggleLoadingRequesting={setLoadingSignature}
                          showLoadingRequesting={loadingSignature}
                          validateInput={props.validateInput}
                          setSigners={props.setSigners}
                          isSignatureTypeSelected={isSignatureTypeSelected}
                          isAtgrafSignature={isAtgrafSignature}
                          signers={props.validators.map((item) => ({
                            ...item,
                            key: "validators",
                          }))}
                          type={"validators"}
                          pdfFile={props.newPdf ?? pdfFile}
                          signatures={signatures}
                          setSignatures={() => dispatch({ type: "setSignatures" })}
                          deleteSignaturesByIndex={(e) => dispatch({ type: "deleteSignatureByIndex", index: e })}
                          DragCell={props.DragCell}
                          changeRows={(dataItem, sum) =>
                            props.changeRows(dataItem, sum, "validators")
                          }
                          toggleDialogDeleteSigner={props.toggleDialogDeleteSigner}
                          processTypeAprovationSequentialChecked={
                            props.processTypeAprovationSequentialChecked
                          }
                          processTypeAprovationChecked={
                            props.processTypeAprovationChecked
                          }
                          processTypeRandomChecked={props.processTypeRandomChecked}
                          processTypeSequentialChecked={
                            props.processTypeSequentialChecked
                          }
                          signatureTypeAutographChecked={
                            props.signatureTypeAutographChecked
                          }
                          signatureTypeAdvancedChecked={
                            props.signatureTypeAdvancedChecked
                          }
                          signatureTypeESignChecked={props.signatureTypeESignChecked}
                          signatureTypeId={props.signatureTypeId}
                        />
                      </div>
                      <br />
                      <br />
                      <br />
                      <div>
                        <Label className="form-inputs-labels">
                          {t("signatureRequestView2.Signers")}
                        </Label>
                        <SequentialSigner
                          booleanValue={props.signersNoPassword}
                          isSequentialSignerAuthorization={true}
                          insertSignBySigner={props.insertSignaturesBySigner}
                          stillSigning={stillSigning}
                          setStillSigning={setStillSigning}
                          currentUser={currentUser}
                          setCurrentUser={setCurrentUser}
                          toggleLoadingRequesting={setLoadingSignature}
                          showLoadingRequesting={loadingSignature}
                          validateInput={props.validateInput}
                          setSigners={props.setSigners}
                          isSignatureTypeSelected={isSignatureTypeSelected}
                          isAtgrafSignature={isAtgrafSignature}
                          signers={props.signers.map((item) => ({
                            ...item,
                            key: "signers",
                          }))}
                          type={"signers"}

                          pdfFile={props.newPdf ?? pdfFile}
                          signatures={signatures}
                          setSignatures={() => dispatch({ type: "setSignatures" })}
                          deleteSignaturesByIndex={(e) => dispatch({ type: "deleteSignatureByIndex", index: e })}
                          DragCell={props.DragCell}
                          changeRows={(dataItem, sum) =>
                            props.changeRows(dataItem, sum, "signers")
                          }
                          toggleDialogDeleteSigner={props.toggleDialogDeleteSigner}
                          processTypeAprovationSequentialChecked={
                            props.processTypeAprovationSequentialChecked
                          }
                          processTypeAprovationChecked={
                            props.processTypeAprovationChecked
                          }
                          processTypeRandomChecked={props.processTypeRandomChecked}
                          processTypeSequentialChecked={
                            props.processTypeSequentialChecked
                          }
                          signatureTypeAutographChecked={
                            props.signatureTypeAutographChecked
                          }
                          signatureTypeAdvancedChecked={
                            props.signatureTypeAdvancedChecked
                          }
                          signatureTypeESignChecked={props.signatureTypeESignChecked}
                          signatureTypeId={props.signatureTypeId}
                          proofLifeCheckboxId={props.proofLifeCheckboxId}
                          showThirdProofLifeCol={canUseOrShowProofOfLife}
                          titleProofLifeCol={t("signatureProfilesView.title.col.biometric validation")}
                        />
                      </div>
                      {props.errorNotSigners && isSignatureTypeSelected && (
                        <span className="hint-message-error">
                          {t("signatureRequestProfileSignersView.signers")}
                        </span>
                      )}
                    </React.Fragment>
                  )}
                {props.showDialogList && (
                  <DialogSignerContainer
                    {...props}
                    isAtgrafSignature={isAtgrafSignature}
                    validator={props.validator}
                    validateInput={props.validateInput}
                    signerTypes={props.signerTypes}
                    dataItem={props.signerInEdit}
                    save={props.save}
                    cancel={props.cancel}
                    dialogTitle={props.dialogTitle}
                    handleSubmit={props.handleSubmit}
                    onDialogInputChange={props.onDialogInputChange}
                    onChangePhoneNumber={props.onChangePhoneNumber}
                    // disableSignerButton={props.disableSignerButton}
                    handleSubmitList={props.handleSubmitList}
                    saveArraSelectedList={props.saveArraSelectedList}
                    userSelectedList={props.userSelectedList}
                    dataDialogGridSelected={props.dataDialogGridSelected}
                  // getGuestName={getGuestName}
                  // getCollaborator={getCollaborator}
                  // getNames={getNames}
                  />
                )}
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
      <div className="action-buttons-sigantures">
        <ButtonHLPure
          nameBtn={back}
          onClickBtn={onHandleBack}
        />
        <ButtonHLPure
          nameBtn={next}
          primary
          onClickBtn={onHandleSubmit}
        />

        {loadingSignature ?
          <DialogSystemGLPure
            {...props}
            message={props.message}
            showLoadingRequesting={loadingSignature}
            toggleLoadingRequesting={setLoadingSignature} /> : null}
      </div>
    </div>
  );
};

export default SignatureRequestProfileSignersView;